import React from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import { authenticationActions } from '../../modules/authentication';

class LoginPage extends React.Component {
    constructor(props) {
        super(props);

        // reset login status
        this.props.logout();

        this.state = {
            userID: '',
            password: '',
            keepLogon: true,
            submitted: false,
            portalAccess: sessionStorage.getItem("portalAccess") || "N" // 포털을 통한 로그인(portalAccess.js) 시 sessionStorage에 "Y" 저장
        };
    }

    keepLogonToggleChange = () => {
        this.setState({
            keepLogon: !this.state.keepLogon,
        });
    }

    enterPressed = (e) => {
        let code = e.keyCode || e.which;
        if(code === 13) { //13 is the enter keycode
            this.buttonLogin.click();
        }
    }

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    handleSubmit = (e) => {
        e.preventDefault();

        this.setState({ submitted: true });
        const { userID, password, keepLogon } = this.state;
        
        if (this.validation()) {
            this.props.login(userID, password, keepLogon);
        }
    }

    validation = () => {
        const { userID, password } = this.state;
        /* const num = password.search(/[0-9]/g);
        const eng = password.search(/[a-z]/ig);
        const spe = password.search(/[`~!@@#$%^&*|₩₩₩'₩";:₩/?]/gi); */
        
        if(!userID) {
            alert('아이디를 입력하세요.');
            return false;
        }else if(!password) {
            alert('비밀번호를 입력하세요.');
            return false;
        }else if(userID.length > 100){
            alert('입력하신 아이디가 너무 깁니다.');
            return false;
        }else if(password.length < 4 || password.length > 20){
            alert("비밀번호는 4자리 ~ 20자리 이내로 입력해주세요.");
            return false;
        }else if(password.search(/\s/) !== -1){
            alert("비밀번호는 공백 없이 입력해주세요.");
            return false;
        /* }else if(num < 0 || eng < 0 || spe < 0 ){
            alert("비밀번호는 영문,숫자, 특수문자를 혼합하여 입력해주세요.");
            return false; */
        }else
            return true;
    };


    render() {
        const { loggingIn } = this.props;
        const { userID, password, submitted, portalAccess } = this.state;

        return (
            <Row className="login-wrapper">
                <Col className="logo-panel">
                    <div className="logo-title">
                        Smart Display
                    </div>
                    <div className="logo-img-wrapper">
                        <img src="/assets/images/ic-img.svg" className="ic-img" alt="Smart Display Logo"></img>
                    </div>
                    {portalAccess !== "N" &&
                    <div style={{textAlign: "center", fontSize: "20px"}}>
                        창을 종료하고 재접속 해주세요.
                    </div>
                    }
                </Col>
                {portalAccess === "N" &&
                <Col className="login-panel">
                    <div className="login-form-wrapper">
                        <div className="form-title">
                            Login
                        </div>
                        <div className={'form-group' + (submitted && !userID ? ' has-error' : '')}>
                            <input className="input-box login-input" placeholder="UserID" type="text" name="userID" value={userID} onChange={this.handleChange} onKeyPress={this.enterPressed} maxLength="100"/><br/>
                            {submitted && !userID &&
                                <div className="help-block">* 아이디는 필수 입력 값입니다.</div>
                            }
                        </div>
                        <div className={'form-group' + (submitted && !password ? ' has-error' : '')}>
                            <input className="input-box login-input" placeholder="Password" type="password" name="password" value={password} onChange={this.handleChange} onKeyPress={this.enterPressed} maxLength="20"/><br/>
                            {submitted && !password &&
                                <div className="help-block">* 비밀번호는 필수 입력 값입니다.</div>
                            }
                        </div>
                        <div className="form-group keep-logon">
                            <input type="checkbox" name="keepLogon" checked={this.state.keepLogon} onChange={this.keepLogonToggleChange}/> 로그인 상태 유지
                        </div>
                        <div className="form-group">
                            <button className="button login-button" onClick={this.handleSubmit} ref={button => this.buttonLogin = button}>로그인</button>
                            {loggingIn &&
                                <img alt="loading" src="/assets/images/loading_s.gif" />
                            }
                        </div>
                    </div>
                </Col>
                }
            </Row>
        );
    }
}

function mapState(state) {
    const { loggingIn } = state.authentication;
    return { loggingIn };
}

const actionCreators = {
    login: authenticationActions.login,
    logout: authenticationActions.logout
};

export default connect(mapState, actionCreators)(LoginPage);